import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CardWrap from "../../Common/CardWrap";
import BootstrapTable from "react-bootstrap-table-next";
import { reportingServices } from "../../../Services/AccountingServices/reporting.service";
import SpinnerLoading from "../../Common/SpinnerLoading";
import paginationFactory from "react-bootstrap-table2-paginator";
import { dateFormatter } from "../../../Helpers/DateHelper";

const MerchandiseCardModal = ({
  show,
  handleClose,
  filters,
  productDetails,
}) => {
  const { t: translator } = useTranslation();

  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (show) {
      setIsLoading(true);
      reportingServices
        .getProductTransactions({
          tenantId: filters.tenantId,
          storeTag: productDetails.storeTag,
          productGuid: productDetails.productGuid,
          from: filters.from,
          to: filters.to,
        })
        .then((res) => {
          setTableData(res?.data?.data);
          setIsLoading(false);
        })
        .catch((err) => err);
    } else {
      setTableData([]);
    }
  }, [show]);

  const exportExcelFunction = () => {
    reportingServices.exportXLSXProductTransactions(
      {
        tenantId: filters.tenantId,
        storeTag: productDetails.storeTag,
        productGuid: productDetails.productGuid,
        from: filters.from,
        to: filters.to,
      },
      `Traffic-Product-${dateFormatter(filters.from)}-${dateFormatter(
        filters.to
      )}`
    );
  };

  const columns = [
    {
      dataField: "documentTypeName",
      text: translator("Traffic-TableHeader-DocumentType"),
    },

    {
      dataField: "fullDocumentNumber",
      text: translator("InitialState-TableHeader-DocumentNumber"),
    },
    {
      dataField: "transactionDate",
      text: translator("Traffic-TableHeader-Date"),
      formatter: dateFormatter,
    },
    {
      dataField: "taxRateName",
      text: translator("EditItem-TaxRate"),
    },

    {
      dataField: "totalQuantityIn",
      text: translator("Traffic-TableHeader-In"),
    },
    {
      dataField: "totalQuantityOut",
      text: translator("Traffic-TableHeader-Out"),
    },
    {
      dataField: "totalQuantityDiff",
      text: translator("Traffic-TableHeader-Diff"),
    },
  ];

  return (
    <Modal show={show} backdrop="static" keyboard={false} size={"xl"} centered>
      <Modal.Body>
        <CardWrap
          subtitle={
            <>
              {translator("ReatailState-ProductDetailsTitle")}
              {tableData?.length > 0 && (
                <span className="badge badge-pill badge-primary ml-2">
                  {tableData.length}
                </span>
              )}
            </>
          }
        >
          <div className="row">
            <div className="col-lg-4">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("InitialState-IndexData")}
                </legend>
                <div className="form-group">
                  <div>
                    <label>
                      <b>{translator("Traffic-DocumentTypeName")}:</b>{" "}
                      {productDetails?.documentTypeName}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>{translator("Filters-ProductGroups")}:</b>{" "}
                      {productDetails?.productGroupName}
                    </label>
                  </div>

                  <div>
                    <label>
                      <b>{translator("Traffic-ProductName")}:</b>{" "}
                      {productDetails?.productName}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>
                        {translator(
                          "Onboarding-DataVerification-StoreDescription"
                        )}
                        :
                      </b>{" "}
                      {productDetails?.storeDescription}
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-lg-8">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("ReatailState-DocumentDetailsTable")}
                </legend>
                {isLoading ? (
                  <div className="dashboard-card-spinner">
                    <SpinnerLoading />
                  </div>
                ) : (
                  <>
                    <BootstrapTable
                      keyField="id"
                      data={tableData}
                      columns={columns}
                      rowClasses="bootstrap-table-row"
                      noDataIndication={translator("No-Data")}
                      pagination={paginationFactory({ hideSizePerPage: true })}
                    />
                    <button
                      className="btn btn-secondary pull-left  mt-2"
                      type="submit"
                      onClick={exportExcelFunction}
                    >
                      {/* <span className="icon icon-search"></span>{" "} */}
                      {translator(".XLSX")}
                    </button>
                  </>
                )}
              </fieldset>
            </div>
          </div>
        </CardWrap>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={handleClose}
          type="button"
          className="btn btn-outline-secondary"
        >
          {translator("General-Close")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MerchandiseCardModal;
